import React from 'react'
import styled from 'styled-components';

// Style　宣言
const FontSizeForty =styled.h3`font-size: 40px`;
const FontSizeThirty =styled.p`font-size: 30px`;
const FontSizeTwenth =styled.p`font-size: 20px`;
const TextLeft =styled.div`padding-left:20px`;
const BackColorMain = styled.div`
    padding: 70px 25px 90px;
    background-image: -webkit-gradient(linear, left bottom, left top, from(#990820), to(#ba0020)) !important;
    background-image: linear-gradient(0deg, #990820 0%, #ba0020 100%) !important;
    color: white;
`;

// トップ各ページのバナーを作成する
const TopBanner = (props) => {
      return (
            <div class="card mb-4">
                <BackColorMain className="row g-0" >
                    <TextLeft className="col-md-4 d-flex align-items-center justify-content-center">
                        <FontSizeForty>{props.title}</FontSizeForty>
                    </TextLeft>
                    <div className="col-md-8">
                        <div className="card-body">
                            <FontSizeThirty className="card-text">{props.text1}</FontSizeThirty>
                            <FontSizeTwenth className="card-text">{props.text2}</FontSizeTwenth>
                            <FontSizeTwenth className="card-text">{props.text3}</FontSizeTwenth>
                            <FontSizeTwenth className="card-text">{props.text4}</FontSizeTwenth>
                        </div>
                    </div>
                </BackColorMain>
            </div>
      );
};

export default TopBanner;